import { render, staticRenderFns } from "./ServiceProviderDetailsTable.vue?vue&type=template&id=cb815786"
import script from "./ServiceProviderDetailsTable.vue?vue&type=script&lang=js"
export * from "./ServiceProviderDetailsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports